import { c as _c } from "react/compiler-runtime";
import { Button, Drawer } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReaderView from './reader-view';
import type { ReportSection } from './report-outline';
type ReportPreviewDrawerProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  sections: ReportSection[];
};
const ReportPreviewDrawer = t0 => {
  const $ = _c(7);
  const {
    open,
    onClose,
    title,
    sections
  } = t0;
  let t1;
  if ($[0] !== sections) {
    t1 = <ReaderView sections={sections} />;
    $[0] = sections;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose || $[3] !== open || $[4] !== t1 || $[5] !== title) {
    t2 = <Drawer onClose={onClose} open={open} size="large" title={title}>{t1}</Drawer>;
    $[2] = onClose;
    $[3] = open;
    $[4] = t1;
    $[5] = title;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
type ReportPreviewButtonProps = {
  name: string;
  sections: ReportSection[];
};
const ReportPreviewButton = t0 => {
  const $ = _c(17);
  const {
    name,
    sections
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.report"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const [open, setOpen] = useState(false);
  let t2;
  if ($[1] !== name || $[2] !== t) {
    t2 = name.trim() || t(_temp);
    $[1] = name;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const title = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpen(true);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Button onClick={t3} size="compact" variant="secondary">{t4}</Button>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpen(false);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== open || $[11] !== sections || $[12] !== title) {
    t7 = <ReportPreviewDrawer onClose={t6} open={open} sections={sections} title={title} />;
    $[10] = open;
    $[11] = sections;
    $[12] = title;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <>{t5}{t7}</>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export { ReportPreviewDrawer };
export default ReportPreviewButton;
function _temp($) {
  return $.untitledReport;
}
function _temp2($_0) {
  return $_0.preview;
}